(function () {
  'use strict';

  var desktopQuery = window.matchMedia('(min-width: 992px)');
  var collectionObserver = null;
  var productDockCleanup = null;

  function isDesktop() {
    return desktopQuery.matches;
  }

  function activateWithKeyboard(element) {
    if (!element || element.dataset.jillleenKeyboardReady === 'true') return;

    element.dataset.jillleenKeyboardReady = 'true';
    if (!element.hasAttribute('tabindex')) element.setAttribute('tabindex', '0');
    if (!element.hasAttribute('role')) element.setAttribute('role', 'button');

    element.addEventListener('keydown', function (event) {
      if (!isDesktop()) return;

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        element.click();
      }

      if (event.key === 'Escape' && element.getAttribute('aria-expanded') === 'true') {
        event.preventDefault();
        element.click();
        element.focus();
      }
    });
  }

  function enhanceViewModes(root) {
    root.querySelectorAll('.collection-template .view-mode').forEach(function (group) {
      if (!group.hasAttribute('role')) group.setAttribute('role', 'radiogroup');
      if (!group.hasAttribute('aria-label')) group.setAttribute('aria-label', 'Products per row');

      group.querySelectorAll('.icon-mode[data-col]').forEach(function (mode) {
        var columns = mode.getAttribute('data-col');
        mode.setAttribute('role', 'radio');
        mode.setAttribute('aria-label', columns === '1' ? 'Show products as a list' : 'Show ' + columns + ' products per row');
        mode.setAttribute('aria-checked', mode.classList.contains('active') ? 'true' : 'false');
        activateWithKeyboard(mode);

        if (mode.dataset.jillleenViewReady !== 'true') {
          mode.dataset.jillleenViewReady = 'true';
          mode.addEventListener('click', function () {
            if (!isDesktop()) return;
            window.setTimeout(function () {
              group.querySelectorAll('.icon-mode[data-col]').forEach(function (item) {
                item.setAttribute('aria-checked', item.classList.contains('active') ? 'true' : 'false');
              });
            }, 0);
          });
        }
      });
    });
  }

  function enhanceDropdowns(root) {
    root.querySelectorAll('.collection-template .label-tab[data-toggle="dropdown"]').forEach(function (trigger, index) {
      var menu = trigger.parentElement ? trigger.parentElement.querySelector('.dropdown-menu') : null;
      var menuId = menu && menu.id ? menu.id : 'JillleenCollectionMenu-' + index;

      if (menu) {
        menu.id = menuId;
        menu.setAttribute('role', 'listbox');
        trigger.setAttribute('aria-controls', menuId);

        menu.querySelectorAll('li > span, li > a').forEach(function (option) {
          option.setAttribute('role', 'option');
          option.setAttribute('tabindex', '-1');
          option.setAttribute('aria-selected', option.parentElement.classList.contains('active') ? 'true' : 'false');

          if (option.dataset.jillleenOptionReady !== 'true') {
            option.dataset.jillleenOptionReady = 'true';
            option.addEventListener('keydown', function (event) {
              if (!isDesktop()) return;

              var options = Array.prototype.slice.call(menu.querySelectorAll('[role="option"]'));
              var currentIndex = options.indexOf(option);
              var nextIndex = currentIndex;

              if (event.key === 'ArrowDown') nextIndex = Math.min(currentIndex + 1, options.length - 1);
              if (event.key === 'ArrowUp') nextIndex = Math.max(currentIndex - 1, 0);
              if (event.key === 'Home') nextIndex = 0;
              if (event.key === 'End') nextIndex = options.length - 1;

              if (nextIndex !== currentIndex) {
                event.preventDefault();
                options[nextIndex].focus();
              }

              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                option.click();
              }

              if (event.key === 'Escape') {
                event.preventDefault();
                trigger.click();
                trigger.focus();
              }
            });
          }
        });
      }

      activateWithKeyboard(trigger);

      if (trigger.dataset.jillleenDropdownReady !== 'true') {
        trigger.dataset.jillleenDropdownReady = 'true';
        trigger.addEventListener('keydown', function (event) {
          if (!isDesktop() || !menu || event.key !== 'ArrowDown') return;
          event.preventDefault();
          if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
          window.setTimeout(function () {
            var firstOption = menu.querySelector('[role="option"]');
            if (firstOption) firstOption.focus();
          }, 0);
        });
      }
    });
  }

  function enhanceFilterGroups(root) {
    root.querySelectorAll('.collection-template .sidebar .widget-title').forEach(function (title, index) {
      var content = title.nextElementSibling;
      if (!content || !content.classList.contains('widget-content')) return;

      var contentId = content.id || 'JillleenFilterGroup-' + index;
      content.id = contentId;
      title.setAttribute('aria-controls', contentId);

      function syncExpandedState() {
        var isHidden = window.getComputedStyle(content).display === 'none';
        title.setAttribute('aria-expanded', isHidden ? 'false' : 'true');
      }

      activateWithKeyboard(title);
      syncExpandedState();

      if (title.dataset.jillleenFilterReady !== 'true') {
        title.dataset.jillleenFilterReady = 'true';
        title.addEventListener('click', function () {
          if (!isDesktop()) return;
          window.setTimeout(syncExpandedState, 0);
        });
      }
    });
  }

  function enhanceCollection(root) {
    if (!isDesktop() || !document.querySelector('.collection-template')) return;
    enhanceViewModes(root);
    enhanceDropdowns(root);
    enhanceFilterGroups(root);
  }

  function watchCollectionChanges() {
    var collection = document.querySelector('.collection-template');
    if (!collection || collectionObserver) return;

    var queued = false;
    collectionObserver = new MutationObserver(function () {
      if (!isDesktop() || queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        enhanceCollection(collection);
      });
    });

    collectionObserver.observe(collection, { childList: true, subtree: true });
  }

  function enhanceProductOptionKeys(productRoot) {
    productRoot.querySelectorAll('.jillleen-product__option-values').forEach(function (group) {
      var options = Array.prototype.slice.call(group.querySelectorAll('[data-jillleen-option]'));

      options.forEach(function (option, index) {
        if (option.dataset.jillleenArrowReady === 'true') return;
        option.dataset.jillleenArrowReady = 'true';

        option.addEventListener('keydown', function (event) {
          if (!isDesktop()) return;

          var nextIndex = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % options.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + options.length) % options.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = options.length - 1;

          if (nextIndex !== index) {
            event.preventDefault();
            options[nextIndex].focus();
            options[nextIndex].click();
          }
        });
      });
    });
  }

  function enhanceProductGalleryKeys(productRoot) {
    var mediaButtons = Array.prototype.slice.call(productRoot.querySelectorAll('[data-gallery-trigger]'));

    mediaButtons.forEach(function (button, index) {
      if (button.dataset.jillleenArrowReady === 'true') return;
      button.dataset.jillleenArrowReady = 'true';

      button.addEventListener('keydown', function (event) {
        if (!isDesktop()) return;

        var nextIndex = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % mediaButtons.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + mediaButtons.length) % mediaButtons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = mediaButtons.length - 1;

        if (nextIndex !== index) {
          event.preventDefault();
          mediaButtons[nextIndex].focus();
          mediaButtons[nextIndex].click();
        }
      });
    });
  }

  function createElement(tagName, className, text) {
    var element = document.createElement(tagName);
    if (className) element.className = className;
    if (typeof text === 'string') element.textContent = text;
    return element;
  }

  function createProductDock(productRoot) {
    if (productDockCleanup || !isDesktop()) return;

    var form = productRoot.querySelector('.jillleen-product__form');
    var purchasePanel = productRoot.querySelector('.jillleen-product__purchase-panel');
    var originalAdd = productRoot.querySelector('[data-jillleen-add-to-cart]');
    var originalQuantity = productRoot.querySelector('.jillleen-product__quantity input[name="quantity"]');
    var originalPrice = productRoot.querySelector('[data-product-price]');
    var title = productRoot.querySelector('.jillleen-product__heading h1');

    if (!form || !purchasePanel || !originalAdd || !originalQuantity || !originalPrice || !title) return;

    var dock = createElement('aside', 'jillleen-commerce-dock');
    dock.setAttribute('aria-label', 'Quick purchase');
    dock.hidden = true;

    var inner = createElement('div', 'jillleen-commerce-dock__inner');
    var identity = createElement('div', 'jillleen-commerce-dock__identity');
    var dockTitle = createElement('strong', 'jillleen-commerce-dock__title', title.textContent.trim());
    var dockPrice = createElement('span', 'jillleen-commerce-dock__price');
    var dockSelection = createElement('div', 'jillleen-commerce-dock__selection');
    var actions = createElement('div', 'jillleen-commerce-dock__actions');
    var quantity = createElement('div', 'jillleen-commerce-dock__quantity');
    var minus = createElement('button', '', '-');
    var quantityOutput = createElement('output', '', originalQuantity.value || '1');
    var plus = createElement('button', '', '+');
    var dockAdd = createElement('button', 'jillleen-commerce-dock__add');

    minus.type = 'button';
    minus.setAttribute('aria-label', 'Decrease quantity');
    plus.type = 'button';
    plus.setAttribute('aria-label', 'Increase quantity');
    quantityOutput.setAttribute('aria-label', 'Quantity');
    dockAdd.type = 'button';

    identity.appendChild(dockTitle);
    identity.appendChild(dockPrice);
    quantity.appendChild(minus);
    quantity.appendChild(quantityOutput);
    quantity.appendChild(plus);
    actions.appendChild(quantity);
    actions.appendChild(dockAdd);
    inner.appendChild(identity);
    inner.appendChild(dockSelection);
    inner.appendChild(actions);
    dock.appendChild(inner);
    document.body.appendChild(dock);

    function selectedOptionsText() {
      return Array.prototype.slice.call(productRoot.querySelectorAll('.jillleen-product__selected-option'))
        .map(function (option) { return option.textContent.trim(); })
        .filter(Boolean)
        .join(' / ');
    }

    function syncDock() {
      var addLabel = originalAdd.querySelector('[data-add-label]');
      dockPrice.textContent = originalPrice.textContent.trim();
      dockSelection.textContent = selectedOptionsText() || 'Ready to add';
      quantityOutput.value = originalQuantity.value || '1';
      quantityOutput.textContent = originalQuantity.value || '1';
      dockAdd.textContent = addLabel ? addLabel.textContent.trim() : originalAdd.textContent.trim();
      dockAdd.disabled = originalAdd.disabled;
      dockAdd.setAttribute('aria-disabled', originalAdd.disabled ? 'true' : 'false');
    }

    function setQuantity(nextValue) {
      var minimum = parseInt(originalQuantity.min || '1', 10);
      var maximum = originalQuantity.max ? parseInt(originalQuantity.max, 10) : Infinity;
      var normalized = Math.min(maximum, Math.max(minimum, nextValue));
      originalQuantity.value = String(normalized);
      originalQuantity.dispatchEvent(new Event('input', { bubbles: true }));
      originalQuantity.dispatchEvent(new Event('change', { bubbles: true }));
      syncDock();
    }

    minus.addEventListener('click', function () {
      if (!isDesktop()) return;
      setQuantity(parseInt(originalQuantity.value || '1', 10) - 1);
    });

    plus.addEventListener('click', function () {
      if (!isDesktop()) return;
      setQuantity(parseInt(originalQuantity.value || '1', 10) + 1);
    });

    dockAdd.addEventListener('click', function () {
      if (!isDesktop() || originalAdd.disabled) return;
      originalAdd.click();
    });

    originalQuantity.addEventListener('input', syncDock);
    originalQuantity.addEventListener('change', syncDock);

    var syncQueued = false;
    var stateObserver = new MutationObserver(function () {
      if (!isDesktop() || syncQueued) return;
      syncQueued = true;
      window.requestAnimationFrame(function () {
        syncQueued = false;
        syncDock();
      });
    });

    stateObserver.observe(productRoot, {
      attributes: true,
      attributeFilter: ['aria-pressed', 'class', 'disabled'],
      characterData: true,
      childList: true,
      subtree: true
    });

    var purchasePassed = false;
    var footerVisible = false;

    function updateDockVisibility() {
      var shouldShow = isDesktop() && purchasePassed && !footerVisible;
      if (shouldShow) {
        dock.hidden = false;
        window.requestAnimationFrame(function () { dock.classList.add('is-visible'); });
      } else {
        dock.classList.remove('is-visible');
        dock.hidden = true;
      }
    }

    var purchaseObserver = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      purchasePassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 96;
      updateDockVisibility();
    }, { rootMargin: '-96px 0px 0px 0px', threshold: 0 });

    purchaseObserver.observe(purchasePanel);

    var footer = document.querySelector('footer, .site-footer');
    var footerObserver = null;
    if (footer) {
      footerObserver = new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        updateDockVisibility();
      }, { threshold: 0 });
      footerObserver.observe(footer);
    }

    syncDock();

    productDockCleanup = function () {
      stateObserver.disconnect();
      purchaseObserver.disconnect();
      if (footerObserver) footerObserver.disconnect();
      originalQuantity.removeEventListener('input', syncDock);
      originalQuantity.removeEventListener('change', syncDock);
      dock.remove();
      productDockCleanup = null;
    };
  }

  function enhanceProduct() {
    if (!isDesktop()) return;
    var productRoot = document.querySelector('[data-jillleen-product]');
    if (!productRoot) return;

    var price = productRoot.querySelector('[data-product-price]');
    var availability = productRoot.querySelector('[data-variant-availability]');
    if (price) price.setAttribute('aria-live', 'polite');
    if (availability) availability.setAttribute('aria-live', 'polite');

    enhanceProductOptionKeys(productRoot);
    enhanceProductGalleryKeys(productRoot);
    createProductDock(productRoot);
  }

  function init() {
    if (!isDesktop()) return;
    enhanceCollection(document);
    watchCollectionChanges();
    enhanceProduct();
  }

  function handleViewportChange(event) {
    if (event.matches) {
      init();
      return;
    }

    if (collectionObserver) {
      collectionObserver.disconnect();
      collectionObserver = null;
    }
    if (productDockCleanup) productDockCleanup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', handleViewportChange);
  } else if (desktopQuery.addListener) {
    desktopQuery.addListener(handleViewportChange);
  }
})();
